export default __webpack_public_path__ + "static/media/venice.623b8aa2.svg";